export default "__VITE_ASSET__e753b630__"